import { render, staticRenderFns } from "./message-details.vue?vue&type=template&id=2cb4756c&scoped=true"
import script from "./message-details.vue?vue&type=script&lang=js"
export * from "./message-details.vue?vue&type=script&lang=js"
import style0 from "./message-details.vue?vue&type=style&index=0&id=2cb4756c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb4756c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cb4756c')) {
      api.createRecord('2cb4756c', component.options)
    } else {
      api.reload('2cb4756c', component.options)
    }
    module.hot.accept("./message-details.vue?vue&type=template&id=2cb4756c&scoped=true", function () {
      api.rerender('2cb4756c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/message/message-details.vue"
export default component.exports